import gql from "graphql-tag";

export const getSSOTemporaryUser = gql`
  query getSSOTemporaryUser($shortCode: String) {
    temporaryUser(shortCode: $shortCode) {
      id
      issuedAt
      validUntil
      revokedAt
      accountId
      tempId
      resourceId
      baseUrl
      link
      shortCode
      token
      userRole
      app
      appId
    }
  }
`;
